export default __webpack_public_path__ + "static/media/icons8-work.c73a6eb6.svg";